import {
  comboBox,
  createFormRow,
  FluidLocale,
  FluidLookup,
  inputField,
  required,
} from '@lmig/fluid-core';

import { mergeTranslations } from '../../address-form.config.utils';
import {
  FluidAddressFormConfig,
  FluidAddressFormConfiguration,
} from '../../fluid-address-form-config.class';
import { defaultAddressTranslations } from './default-address.translations';

export const defaultAddressConfig = (config: FluidAddressFormConfiguration) => {
  // Step 2 - Creating The Configuration Instance
  const addressForm: FluidAddressFormConfig = new FluidAddressFormConfig(
    FluidLocale.DEFAULT,
    mergeTranslations(config, defaultAddressTranslations)
  );

  // Step 3 - Creating The Layout
  addressForm.setRowOptions([
    createFormRow(1, [12]),
    createFormRow(2, [12]),
    createFormRow(3, [12]),
    createFormRow(4, [12]),
    createFormRow(5, [6, 6]),
  ]);

  // Step 4 - Defining The Fields
  addressForm.setElements([
    comboBox({
      ...addressForm.field('country', 1, 1),
      options: FluidLookup.country,
      validation: [
        required({
          message: addressForm.translate('country', 'validation.required'),
        }),
      ],
    }),
    inputField({
      ...addressForm.field('addressLineOne', 2, 1),
    }),
    inputField({
      ...addressForm.field('addressLineTwo', 3, 1),
    }),
    inputField({
      ...addressForm.field('townOrCity', 4, 1),
    }),
    inputField({
      ...addressForm.field('countyOrProvince', 5, 2),
    }),
    inputField({
      ...addressForm.field('postOrZipCode', 5, 1),
      validation: [
        required({
          message: addressForm.translate(
            'postOrZipCode',
            'validation.required'
          ),
        }),
      ],
    }),
  ]);

  return addressForm;
};
